class ScrollPositionHelper {
  preserveScrollPosition = false;

  preservePositionOnce = () => {
    this.preserveScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  }

  allowFocus = () => this.preserveScrollPosition === false

  setScrollPosition = () => {
    if (typeof this.preserveScrollPosition === 'number') {
      window.scrollBy(0, this.preserveScrollPosition);
    }
  }

  resetScrollPosition = () => {
    this.preserveScrollPosition = false;
  }
}

export default new ScrollPositionHelper();
